<ng-container *ngIf="{
    rioDataEvaluationOverview: rioDataEvaluationOverview$ | async,
    errorOverview: errorOverview$ | async,
  } as type">

  <ng-cotainer *ngIf=" (searchFilters$ | async)">
    <!--FILTERS-->
    <div class="vendor-reporting-filter" id="vendor-reporting-filter">
        <form (ngSubmit)="onSubmit()" #searchForm="ngForm" autocomplete="off">
            <ng-container>
                <div class="form-group row">
                    <label for="productCode" class="col-md-2 col-form-label">{{
                        'customVendorReporting.search.productCode' | cxTranslate
                        }}</label>
                    <div class="col-md-2">
                        <input type="text" id="productCode" class="form-control" [(ngModel)]="filters.productCode" name="productCode"
                            [value]="filters.productCode" />
                    </div>
                    <label for="ean" class="col-md-2 col-form-label">{{
                        'customVendorReporting.search.ean' | cxTranslate
                        }}</label>
                    <div class="col-xl-6">
                        <input type="text" id="ean" class="form-control" [(ngModel)]="filters.ean" name="ean" [value]="filters.ean" />
                    </div>
                </div>
                <div class="form-group row">
                    <label for="manufacturer" class="col-md-2 col-form-label">{{
                        'customVendorReporting.search.manufacturer' | cxTranslate
                        }}</label>
                    <ng-select id="manufacturer" class="col-xl-2" [searchable]="false" [clearable]="false" [(ngModel)]="filters.manufacturer"
                        name="manufacturer">
                        <ng-option value="">{{ 'customVendorReporting.search.all' | cxTranslate }}</ng-option>
                        <ng-option *ngFor="let manufacturerMapping of (manufacturersList$ | async)"
                            [value]="manufacturerMapping">
                            <div>{{ manufacturerMapping }}</div>
                        </ng-option>
                    </ng-select>

                    <label for="reportTransferType" class="col-md-2 col-form-label">{{
                        'customVendorReporting.search.reportTransferType' | cxTranslate
                        }}</label>
                    <ng-select id="reportTransferType" class="col-xl-6" [searchable]="false" [clearable]="false"
                    (change)="onReportTransferTypeChange()" [(ngModel)]="filters.reportTransferType" name="reportTransferType">
                        <ng-option *ngFor="let reportTransferType of reportTransferTypesList" [value]="reportTransferType">{{
                            'customVendorReporting.reportTransferTypes.' + reportTransferType | cxTranslate
                            }}</ng-option>
                    </ng-select>

                </div>
                <div class="form-group row">
                    <label for="b2bUnit" class="col-md-2 col-form-label">{{ 'customVendorReporting.search.b2bUnit' | cxTranslate }}</label>
                        <div class="col-xl-2">
                        <input type="text" id="b2bUnit" class="form-control" [(ngModel)]="filters.b2bUnit" name="b2bUnit" [value]="filters.b2bUnit" />
                        </div>
                        <label for="manufacturerNumber" class="col-md-2 col-form-label">{{
                        'customVendorReporting.search.manufacturerNumber' | cxTranslate
                        }}</label>
                    <div class="col-xl-6">
                        <input type="text" id="manufacturerNumber" class="form-control" [(ngModel)]="filters.supplierProductCode"
                            name="manufacturerNumber" [value]="filters.supplierProductCode" />
                    </div>
                </div>
                <div class="form-group row">

                    <label for="transferPeriodLabel" class="col-md-1 col-form-label">{{
                        'customVendorReporting.search.transferPeriodLabel' | cxTranslate
                        }}</label>
                    <label for="transferDateFrom" class="col-md-1 col-form-label">{{
                                'customVendorReporting.search.transferDateFrom' | cxTranslate
                        }}</label>
                    <div class="col-xl-2">
                        <input type="date" id="transferDateFrom" class="form-control" name="transferDateFrom" [(value)]="filters.transferDateFrom"
                            [(ngModel)]="filters.transferDateFrom" max="{{filters.transferDateTo}}" (change)="validateTransferDateFrom()" />
                    </div>
                    <label for="transferDateTo" class="col-xl-2 col-form-label">{{
                        'customVendorReporting.search.transferDateTo' | cxTranslate
                        }}</label>
                    <div class="col-xl-2">
                        <input type="date" id="transferDateTo" class="form-control" name="transferDateTo" [(ngModel)]="filters.transferDateTo"
                            [(value)]="filters.transferDateTo" min="{{ filters.transferDateFrom }}" (change)="validateTransferDateTo()" />
                    </div>
                </div>

            </ng-container>
            <div class="form-group row">
                <div class="col-sm-3">
                    <button class="btn btn-secondary btn-block mb-3" type="submit">
                        {{ 'customVendorReporting.buttons.search' | cxTranslate }}
                    </button>
                </div>
                <div class="col-sm-2">
                    <button class="btn btn-secondary btn-block mb-3" type="button" (click)="resetForm()">
                        {{ 'customVendorReporting.buttons.reset' | cxTranslate }}
                    </button>
                </div>
                <div class="col-sm-4">
                    <button type="button" class="btn btn-secondary btn-block mb-3" type="button">
                        {{ 'customVendorReporting.buttons.instruction' | cxTranslate }}
                    </button>
                </div>
                <div class="col-sm-3">
                    <button type="button" class="btn btn-secondary btn-block mb-3" type="button" (click)="onExport()">
                        {{ 'customVendorReporting.buttons.export'   | cxTranslate }}
                    </button>
                </div>
            </div>
        </form>
    </div>
    <!-- SORT -->
    <div class="vendor-reporting-sort">
        <div class="form-group row">
            <label for="vendorReportingSorting" class="sort-options-label col-sm-12 col-form-label">{{
                'customVendorReporting.rioSortOptions.label' | cxTranslate
                }}</label>
            <ng-select id="sortOptions" class="sort-options-dropdown col-sm-12 col-xl-3" [searchable]="false" [clearable]="false"
                (change)="onChangeSort()" [(ngModel)]="selectedSortOption">
                <ng-option *ngFor="let sort of sortOptions" [value]="sort">{{
                    'customVendorReporting.rioSortOptions.' + sort | cxTranslate
                    }}</ng-option>
            </ng-select>
            <label for="sortDirections" class="sort-directions-label col-sm-12 col-form-label">{{
                'customVendorReporting.sortDirections' | cxTranslate
                }}</label>
            <div class="sort-direction-btn col-sm-12 col-form-label">
                <div class="form-check">
                    <input class="form-check-input" type="radio" name="sortDirection" id="sortDirectionDesc" value="desc"
                        ng-control="sortDirection" [(ngModel)]="sortDirection" (change)="onChangeSort()" />
                    <label class="form-check-label" for="sortDirectionDesc">
                        {{ 'customVendorReporting.sortDirection.desc' | cxTranslate }}
                    </label>
                </div>
            </div>
            <div class="sort-direction-btn col-sm-12 col-form-label">
                <div class="form-check">
                    <input class="form-check-input" type="radio" name="sortDirection" id="sortDirectionAsc" value="asc" ng-control="sortDirection"
                        [(ngModel)]="sortDirection" (change)="onChangeSort()" />
                    <label class="form-check-label" for="sortDirectionAsc">
                        {{ 'customVendorReporting.sortDirection.asc' | cxTranslate }}
                    </label>
                </div>
            </div>
        </div>
    </div>
        <div class="import-container">
            <hr>
            <div class="import-header row">
                <div class="col-md-6 col-sm-6">
                    <p class="title"> {{ 'customVendorReporting.dataEvaluation.noOfRecords' | cxTranslate }} </p>
                    <p class="text"> {{ rioEvaluationStatisticsData?.searchResultRecordCount }} </p>
                </div>
                <div class="col-md-6 col-sm-6">
                    <p class="title"> {{ 'customVendorReporting.dataEvaluation.noOfArticles' | cxTranslate }} </p>
                    <p class="text"> {{ rioEvaluationStatisticsData?.searchResultProductCount}} </p>
                </div>
            </div>

            <div class="import-header row">
                <div class="col-md-6 col-sm-6">
                    <p class="title"> {{ 'customVendorReporting.dataEvaluation.noOfDealers' | cxTranslate }} </p>
                    <p class="text"> {{ rioEvaluationStatisticsData?.searchResultB2BUnitCount }} </p>
                </div>
                <div class="col-md-6 col-sm-6">
                    <p class="title"> {{ 'customVendorReporting.dataEvaluation.noOfQuantity' | cxTranslate }} </p>
                    <p class="text"> {{ rioEvaluationStatisticsData?.searchResultQuantityCount}} </p>
                </div>
            </div>
        </div>


    <ng-template #loading>
        <cx-spinner></cx-spinner>
    </ng-template>

    <ng-container *ngIf="(rioDataEvaluationOverview || errorOverview) && ((isFilteringrSuccessfullyTransferred$ |async) === false); else loading">
        <!-- TABLE -->
        <table class="table vendor-reporting-table" aria-describedby="vendor-reporting-table">
            <thead class="vendor-reporting-header">
                <th scope="col" class="manufacturer">
                    {{ 'customVendorReporting.manufacturer' | cxTranslate }}
                </th>
                <th scope="col" class="reportTransferType">
                    {{ 'customVendorReporting.reportTransferType' | cxTranslate }}
                </th>
                <th scope="col" class="b2bUnit">
                      {{ 'customVendorReporting.b2bUnit' | cxTranslate }}
                </th>
                <th scope="col" class="storeID">
                      {{ 'customVendorReporting.storeID' | cxTranslate }}
                </th>
                <th scope="col" class="transferDate">
                    {{ 'customVendorReporting.date' | cxTranslate }}
                </th>
                <th scope="col" class="productCode">
                    {{ 'customVendorReporting.productCode' | cxTranslate }}
                </th>
                <th scope="col" class="manufacturerNumber">
                      {{ 'customVendorReporting.manufacturerNumber' | cxTranslate }}
                </th>
                <th scope="col" class="ean">
                    {{ 'customVendorReporting.ean' | cxTranslate }}
                </th>
                <th scope="col" class="online">
                    {{ 'customVendorReporting.onlineSale' | cxTranslate }}
                </th>
                <th scope="col" class="salesType">
                    {{ 'customVendorReporting.salesType' | cxTranslate }}
                </th>
                <th scope="col" class="timestamp">
                    {{ 'customVendorReporting.quantity' | cxTranslate }}
                </th>
            </thead>
            <tbody>
                <tr *ngIf="vendorReportTransferDataList.length === 0">
                    <td colspan="11">
                        {{ 'customVendorReporting.emptyTable' | cxTranslate }}
                    </td>
                </tr>
                <tr *ngFor="let vendorReportTransferData of vendorReportTransferDataList">
                        <td class="manufacturer">
                            <div class="d-md-none vendor-reporting-label">
                                {{ 'customVendorReporting.b2bUnit' | cxTranslate }}
                            </div>
                            <div class="vendor-reporting-value">
                                <a class="vendor-reporting-value">
                                    {{ vendorReportTransferData?.manufacturer}}</a>
                            </div>
                        </td>

                        <td class="reportTransferType">
                            <div class="d-md-none vendor-reporting-label">
                                {{ 'customVendorReporting.reportTransferType' | cxTranslate }}
                            </div>
                            <div class="vendor-reporting-value">
                                <a class="vendor-reporting-value">
                                    {{ 'customVendorReporting.reportTransferTypes.' + vendorReportTransferData?.reportTransferType | cxTranslate }}</a>
                            </div>
                        </td>
                    <td class="b2bUnit">
                        <div class="d-md-none vendor-reporting-label">
                            {{ 'customVendorReporting.manufacturer' | cxTranslate }}
                        </div>
                        <div class="vendor-reporting-value">
                            <a class="vendor-reporting-value">
                                {{ vendorReportTransferData?.b2bUnit}}</a>
                        </div>
                    </td>
                    <td class="storeID">
                      <div class="d-md-none vendor-reporting-label">
                        {{ 'customVendorReporting.storeID' | cxTranslate }}
                      </div>
                      <div class="vendor-reporting-value">
                        <a class="vendor-reporting-value">
                          {{ vendorReportTransferData?.storeId}}</a>
                      </div>
                    </td>
                    <td class="reportTransferPeriod">
                        <div class="d-md-none vendor-reporting-label">
                            {{ 'customVendorReporting.reportTransferPeriod' | cxTranslate }}
                        </div>
                        <div class="vendor-reporting-value">
                            <a class="vendor-reporting-value">
                                {{ vendorReportTransferData?.date | cxDate}}</a>
                        </div>
                    </td>
                    <td class="productCode">
                        <div class="d-md-none vendor-reporting-label">
                            {{ 'customVendorReporting.productCode' | cxTranslate }}
                        </div>
                        <div class="vendor-reporting-value">
                            <a class="vendor-reporting-value">
                                {{ vendorReportTransferData?.productCode }}</a>
                        </div>
                    </td>
                    <td class="manufacturerNumber">
                        <div class="d-md-none vendor-reporting-label">
                            {{ 'customVendorReporting.manufacturerNumber' | cxTranslate }}
                        </div>
                        <div class="vendor-reporting-value">
                            <a class="vendor-reporting-value">
                                {{ vendorReportTransferData?.manufacturerPartNumber }}</a>
                        </div>
                    </td>

                    <td class="ean">
                        <div class="d-md-none vendor-reporting-label">
                            {{ 'customVendorReporting.ean' | cxTranslate }}
                        </div>
                        <div class="vendor-reporting-value">
                            <a class="vendor-reporting-value">
                                {{ vendorReportTransferData?.gtin }}</a>
                        </div>
                    </td>

                    <td class="onlineSale">
                        <div class="d-md-none vendor-reporting-label">
                            {{ 'customVendorReporting.onlineSale' | cxTranslate }}
                        </div>
                        <div class="vendor-reporting-value">
                            <a class="vendor-reporting-value">
                                {{ vendorReportTransferData?.onlineSale}}</a>
                        </div>
                    </td>
                    <td class="manufacturer">
                        <div class="d-md-none vendor-reporting-label">
                            {{ 'customVendorReporting.partnerID' | cxTranslate }}
                        </div>
                        <div class="vendor-reporting-value">
                            <a class="vendor-reporting-value">
                                {{ vendorReportTransferData?.transactionType}}</a>
                        </div>
                    </td>

                    <td class="quantity">
                        <div class="d-md-none vendor-reporting-label">
                            {{ 'customVendorReporting.quantity' | cxTranslate }}
                        </div>
                        <div class="vendor-reporting-value">
                            <a class="vendor-reporting-value">
                                {{ vendorReportTransferData?.quantity}}</a>
                        </div>
                    </td>

                  </tr>
            </tbody>
            <!--  -->
        </table>
    </ng-container>
</ng-cotainer>

